const EVENT_SLUG = 'scorpions-with-special-guests-europe-arena-zagreb-cf3d'
const ARTIST_PRESALE_START = Date.parse('2026-11-04T11:00:00+01:00')
const LOCAL_PRESALE_START = Date.parse('2026-11-05T11:00:00+01:00')
const GENERAL_SALE_START = Date.parse('2026-11-06T11:00:00+01:00')

// This event's links control presentation only; passwords keep their usual verification.
export function getScorpionsSaleDisplay(eventSlug, sale, now = Date.now()) {
  if (eventSlug !== EVENT_SLUG) return null

  const timestamp = new Date(now).getTime()
  if (timestamp >= GENERAL_SALE_START) return 'general-open'

  const normalizedSale = typeof sale === 'string' ? sale.trim().toLowerCase() : ''
  const presaleStart = normalizedSale === 'artist-presale'
    ? ARTIST_PRESALE_START
    : ['local-presale', 'promotor-presale'].includes(normalizedSale) ? LOCAL_PRESALE_START : null

  if (presaleStart !== null) {
    return timestamp < presaleStart ? 'presale-unavailable' : 'presale-password'
  }

  return 'general-unavailable'
}
